import React from "react";
import { any } from "prop-types";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import ListItem from "@mui/material/ListItem";
import IconButton from "@mui/material/IconButton";
import pdfLogo from "../../../assets/svg/pdf-logo.svg";
import "../SelectedFileList/selectedFileList.scss";
import { Box } from "@mui/material";

const BulkBatchCheckBoxList = ({
  checked,
  item,
  onClick,
  selectAllChecked,
  selectedFiles,
}) => {
  return (
    <Box>
      <ListItem onClick={() => onClick(item)}>
        <ListItemButton dense>
          <ListItemIcon>
            <Checkbox
              size="small"
              //   checked={checkChecked(checked, item)}
              tabIndex={-1}
              // onClick={() => onClick(item)}
              checked={selectedFiles.some(
                (selectedItem) => selectedItem?.file_name === item?.file_name
              )}
            />
          </ListItemIcon>
          <IconButton>
            <img className="checkboxTitleIcon" src={pdfLogo} alt="Pdf Icon" />
          </IconButton>
          <ListItemText
            className="checkboxTitleIcon-title"
            size="small"
            primary={item.file_name}
            style={{
              // maxWidth: "170px",
              textOverflow: "ellipsis",
            }}
          />
        </ListItemButton>
      </ListItem>
    </Box>
  );
};

BulkBatchCheckBoxList.propTypes = {
  checked: any,
  item: any,
  onClick: any,
};

export default BulkBatchCheckBoxList;
